module.exports = __webpack_public_path__ + "img/header_img9.320a7ecd.png";